const enGB = {
  navigation: {
    mydevice: "My device",
    mymobile: "My mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Photos",
      favorites: "Favorites",
      collections: "Collections",
      events: "Events",
      latestuploads: "Latest uploads"
    },
    empty(source) {
      return "You have no photos in " + source
    }
  },
  mymobile: {
    title: "Get your phone photos in an instant!",
    qrcode: {
      title: "Scan the QR code",
      subtitle: "(No need to install App)"
    },
    instruction: {
      title: "Let's get started!",
      step_1: "Open your camera app",
      step_2: "Scan the QR code",
      step_3: "Follow the instruction on your mobile"
    }
  },
  layout: {
    flex: "Flex",
    square: "Square"
  },
  calender: {
    allmonths: "All months",
    allyears: "All years",
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December"
    }
  },
  generic: {
    sortBy: "Sort by",
    selected: "selected",
    done: "Add photos",
    back: "Back",
    images: "photos",
    selection: "Selection",
    date: "Date",
    name: "Name",
    az: "Filename A-Z",
    za: "Filename Z-A",
    newestfirst: "Date taken new-old",
    oldestfirst: "Date taken old-new",
    photos: "photos",
    all: "All",
    yes: "yes",
    no: "no",
    nodate: "No date"
  },
  rangeText: {
    minMax(min, max) {
      return "You must pick between " + min + " and " + max + " photos"
    },
    min(min) {
      return "You’ll need at least " + min + " photos to create your book."
    },
    max(max) {
      return "You can maximum pick " + max + "  photos"
    }
  },
  addMorePhotos: "Add more photos",
  upload: {
    browseButton: "Add photos",
    uploadlimit(maxSize) {
      return "Photos must be smaller than " + maxSize + " in file size"
    },
    dragImage: "or drag and drop photos here.",
    errors: {
      GENERIC_ERROR: "Something went wrong. Please try again later or contact customer care.",
      EMPTY_FILE: "Image reference lost, please add image again",
      MAX_FILE_SIZE: "File needs to be smaller than {0} mb",
      UNSUPPORTED_FILE_TYPE: "File format is not supported",
      MAX_IMAGE_RESOLUTION: "File needs to be smaller than {0} pixels",
      INVALID_IMAGE: "File is broken"
    },
    errorSummary(number) {
      return number + " files could not be uploaded"
    },
    errorDialog: {
      headline: "Oops!",
      ingress: "The following files could not be uploaded:",
      filenameColumn: "File",
      reasonColumn: "Reason"
    },
    uploaded: "Uploaded",
    estimating: "Estimating time",
    estimatedleft: "Estimated time left",
    ok: "OK",
    cancel: "Cancel",
    details: "Details"
  }
}

export default enGB
